module.exports = __webpack_public_path__ + "img/support.15916071.svg";